<template>
<a-modal v-model="visible11" title="引用易制毒证件" width="1020px" :footer="null">
  <div>
    <div style="width:100%; display: flex;justify-content: space-between;background: #F4F4F4;height:40px;line-height: 40px;padding:0 20px">
      <span style="width:140px">证件名称</span>
      <span>上传时间</span>
      <span>申请使用次数</span>
      <span>购买数量</span>
      <span>剩余次数</span>
      <span>操作</span>
    </div>
    <div v-for="(item, index) in data" :key="index" >
      <!-- {{item}} -->
      <a-radio-group v-model="value" @change="disabled1(item,index)" style="width:100%">
        <a-radio :value="item.uuid" style="margin:10px 0;background:#e6e6e6;height:40px;line-height: 40px; width:100%;padding:0 10px;">
          <span style="margin-right:10px">易制毒危险化学品合法用途说明</span>
          <span style="margin-right:60px">{{item.createdAt}}</span>
          <span style="margin-right:150px">{{item.allow.validNum}}</span>
          <a-input style="width:80px;margin-right:90px" :min="1" type="number" id="value" />
          <span  style="margin-right:60px">{{item.allow.residueNum}} &emsp;</span>
          <a-button :disabled="item.allow.disabled" @click="onChange(item,index)">确定引用</a-button>
        </a-radio>
      </a-radio-group>
    </div>
  </div>
</a-modal>
</template>
<script>
import ImgUpload from './ImgUpload'
export default {
  components: {
    ImgUpload
  },
  data() {
    return {
      visible11: false,
      data: [],
      value: '',
      buyQuantity: null,
      item: {}
    };
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
        this.api.getmyPageDu().then((res) => {
        let data = res.data.content
        for (let i = 0; i < data.length; i++) {
          data[i].allow.disabled = true
        }
        this.data = data
        console.log(this.data, '--------')
      })
    },
    disabled1 (item,index) {
      console.log(this.data);
      this.data.forEach(e => {
        console.log(e.allow.uuid,item.allow.uuid)
        if (e.uuid == item.uuid) {
          e.allow.disabled = false
        } else {
          e.allow.disabled = true
        }
      })
      this.data[index].allow.disabled = false
      let val = document.getElementById("value").value
      let all = JSON.stringify(item)
      item = JSON.parse(all)
      item.allow.buyQuantity = val * 1
      this.item = item
    },
    onChange (item, i) {
        let val = document.getElementById("value").value
        if (val == '') {
          this.$message.error('请先填写购买数量')
        }else {
        //   let all = JSON.stringify(item)
        //   item = JSON.parse(all)
        //   item.allow.buyQuantity = val * 1
          this.api.pushYizhidu_detail(this.item).then((res) => {
            if (res.ok === true) {
              this.$message.success(res.message)
              this.zhenshuUuid = res.data.uuid
              this.visible11 = false
              console.log(this.zhenshuUuid, '新增的证书uuid')
              this.visible11 = false
              this.$emit('child-event', res.data.uuid)
            } else {
              this.$message.error(res.message)
            }
          })
        }
    },
  },
};
</script>

<style scoped>
   /deep/.ant-form-item{
    margin-bottom: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ImgUpload/YizhiDu.vue